import { useModuleBEM } from "@b2bportal/core-themes";
import { ToggleGroup } from "@hsbc/portal";
import {
  type UseFlightCategorySelectionParams,
  useFlightCategorySelection,
} from "@tenant/flights";
import styles from "./styles.module.scss";

interface FlightCategorySelectionProps
  extends UseFlightCategorySelectionParams {
  className?: string;
}

export const FlightCategorySelection = (
  props: FlightCategorySelectionProps
) => {
  const { selectedTripCategoryState, getCategoryOptions, handleOnChange } =
    useFlightCategorySelection(props);
  const [block] = useModuleBEM(styles, "FlightCategorySelection");

  const defaultOption = getCategoryOptions().find(
    (option) => option.value === selectedTripCategoryState
  );

  return (
    <div className={block}>
      <ToggleGroup
        options={getCategoryOptions()}
        defaultOption={defaultOption}
        onChange={handleOnChange}
      />
    </div>
  );
};
